import { render, staticRenderFns } from "./OrderConfirmedForm.vue?vue&type=template&id=26bf614a"
import script from "./OrderConfirmedForm.vue?vue&type=script&lang=js"
export * from "./OrderConfirmedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports